import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import MetasGerais from '../../components/MetasGerais/MetasGerais';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function MetasGeraisAdm() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <MetasGerais  setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}